import { SvgIconProps } from '@mui/material';
import { useFeatureFlag } from 'providers';
import DrinksImage from 'assets/images/img-drinks.jpg';
import SoftailImage from 'assets/images/img-piccante-softail.jpg';

function Drinks({ height = '113', width = '115', className }: SvgIconProps) {
  const allowSpinToWin = useFeatureFlag('allowSpinToWin');

  return (
    <>
      {allowSpinToWin ? (
        <svg viewBox="0 0 143 140" width={width} height={height} fill="none" className={className}>
          <path
            d="M8.233 80.131c-9.4-15.254-11.217-35.461-3.022-52.12 2.213-4.5 5.608-8.302 9.083-11.919 4.176-4.35 8.606-8.58 13.897-11.477C40.213-1.973 60.54-.317 73.42 2.293c64.11 13 50.736 125.196-17.159 109.138-11.902-2.816-22.683-9.064-32.948-15.706-6.173-3.997-11.255-9.386-15.08-15.594Z"
            fill="url(#drinks_svg_a)"
          />
          <defs>
            <pattern id="drinks_svg_a" patternContentUnits="objectBoundingBox" width={1} height={1}>
              <use xlinkHref="#drinks_svg_b" transform="matrix(.0005 0 0 .0005 -.237 0)" />
            </pattern>
            <image id="drinks_svg_b" width={3000} height={2000} xlinkHref={DrinksImage} />
          </defs>
        </svg>
      ) : (
        <svg
          viewBox="0 -18 143 140"
          width={width}
          height={height}
          fill="none"
          className={className}
        >
          <path
            d="M8.233 80.131c-9.4-15.254-11.217-35.461-3.022-52.12 2.213-4.5 5.608-8.302 9.083-11.919 4.176-4.35 8.606-8.58 13.897-11.477C40.213-1.973 60.54-.317 73.42 2.293c64.11 13 50.736 125.196-17.159 109.138-11.902-2.816-22.683-9.064-32.948-15.706-6.173-3.997-11.255-9.386-15.08-15.594Z"
            fill="url(#softail_svg_a)"
          />
          <defs>
            <pattern
              id="softail_svg_a"
              patternContentUnits="objectBoundingBox"
              width={1}
              height={1}
            >
              <use xlinkHref="#softail_svg_b" transform="matrix(.0005 0 0 .0005 -.237 0)" />
            </pattern>
            <image id="softail_svg_b" width={3000} height={2000} xlinkHref={SoftailImage} />
          </defs>
        </svg>
      )}
    </>
  );
}

export default Drinks;
